import { createTheme } from "@mui/material";
import { AppTheme } from "./index";

export const createMuiTheme = (baseTheme: AppTheme) => {
  return createTheme({
    palette: baseTheme.palette,
    typography: baseTheme.typography,
    breakpoints: baseTheme.breakpoints,
  });
};
